import React, { Component } from "react";
// import { connect } from 'react-redux';
import { reactLocalStorage } from "reactjs-localstorage";

import { Modal, Table, Button } from "antd";
import { formatDate, amountFormat } from "../../util";
import { httpUrl, httpGet } from "../../api/httpClient";
import Const from "../../const";

export default class WalletModal extends Component {

  state = {
    stakingBalace: 0
  };

  componentDidUpdate(prevProps) {
    if (prevProps.name.idx != this.props.name.idx) {
      if (Const.appName == 'bbt') {
        httpGet(httpUrl.bbtStakingBalance, [this.props.name.idx], {}).then(result => {
          this.setState({stakingBalace: amountFormat(result.data, 401)})
        }).catch(e=>{
          this.setState({stakingBalace: 0})
        })
      }
    }
  }
  onUpdateBalance = data => {
    httpGet(httpUrl.updateUserBalance, [data.address, data.coinType], {}).then(
      res => {
        alert("갱신이 완료 되었습니다.");
        this.props.showSerialNumber({
          pageNum: this.props.pagination.current
        });
      }
    );
  };

  render() {
    const { visible, onOk, modalData } = this.props;
    const coinList = reactLocalStorage.getObject("coinList");

    const walletColums = [
      // {
      //   title: "생성일",
      //   dataIndex: "createDate",
      //   // width: 80,
      //   className: "support-column-number fs-15 lh-21",
      //   render: data => <div>{formatDate(data)}</div>
      // },
      {
        title: "종류",
        dataIndex: "coinType",
        key: "coinType",
        className: "support-column-number fs-15 lh-21",
        render: data => (
          <div align="left">
            {coinList.find(coin => coin.coinType === data)
              ? coinList.find(coin => coin.coinType === data).name
              : ""}
          </div>
        )
      },
      {
        title: "지갑주소",
        dataIndex: "address",
        className: "support-column-number fs-15 lh-21",
        render: data => (
          <div align="left">
            {data}
          </div>
  
  )
},
{
  title: "잔액",
  dataIndex: "balance",
  className: "support-column-number fs-15 lh-21",
  render: (data, row) => <div align="right">{amountFormat(data, row.coinType)}</div>
},
      
    ];
    // alert(JSON.stringify(this.props.name,['name ']));
    return (
      <Modal
        visible={visible}
        title={this.props.name.name +  " ("+ this.props.name.id +")"+ " 님의 지갑잔액"}
        onCancel={onOk}
        style={{ minWidth: "700px"}}
        footer={null}>
        <div className="wallet-log-wrapper">
          {Const.appName == 'bbt' && (
            <div style={{paddingBottom: '10px', color: 'blue'}}>스테이킹: {this.state.stakingBalace}</div>
          )}
        
          <Table
            id="wallet-log-table"
            rowKey={record => record.coinType}
            columns={walletColums}
            dataSource={modalData}
            pagination={this.props.pagination}
            onChange={this.props.handleTableChange}
            style={{ marginBottom: "10px"}}
          />
        </div>
      </Modal>
    );
  }
}
